export type TournamentMatchEventType =
  | "match_entries_set"
  | "match_assigned"
  | "match_unassigned"
  | "match_started"
  | "match_completed"
  | "match_result_recorded"
  | "match_voided";

export type TournamentEventType =
  | "entry_registered"
  | "entry_withdrawn"
  | "winner_selected"
  | "tournament_setting_changed"
  | "playoff_division_set"
  | "playoff_divisions_reset"
  | TournamentMatchEventType;

/** Why a match was voided. Stored in event payload so new reasons need no migration. */
export type MatchVoidReason = "no_show";

export interface MatchVoidPayload {
  reason: MatchVoidReason;
  /** Entries responsible for the void (e.g. unchecked no-shows). */
  responsible_entry_ids?: string[];
}

export interface MatchSlotReference {
  slot_id: string;
  round: number;
  match_index: number;
  division?: number;
}

export interface TournamentEventPayloadBase {
  slot?: MatchSlotReference;
  [key: string]: unknown;
}

export interface TournamentEventRecord {
  id: string;
  event_type: TournamentEventType;
  payload: TournamentEventPayloadBase;
  created_at?: Date;
  client_id?: string;
  client_seq?: number;
}

export interface MatchProjectionMetadata {
  slot_id: string;
  round: number;
  match_index: number;
  division?: number;
  status?: "pending" | "ready" | "in_progress" | "completed" | "voided";
  court_id?: string;
  score?: Record<string, unknown>;
  started_at?: Date;
  completed_at?: Date;
  voided_at?: Date;
  void_reason?: MatchVoidReason;
  void_responsible_entry_ids?: string[];
}

export function getMatchSlotId(round: number, matchIndex: number, division?: number): string {
  if (division !== undefined) {
    return `r${round}:m${matchIndex}:d${division}`;
  }
  return `r${round}:m${matchIndex}`;
}

export function matchVoidDisplayLabel(reason?: MatchVoidReason | string): string {
  if (reason === "no_show") return "No show · Void";
  return "Voided";
}
